/**
 * Rutas que nunca deben indexarse (internas, de cuenta, de embudo o fuera
 * de la adquisición SEO actual). robots.txt NO las bloquea todas a propósito:
 * Google necesita rastrearlas para leer el noindex.
 */
export const NOINDEX_PREFIXES = [
  "/admin",
  "/dashboard",
  "/bienvenida",
  "/rh",
  "/acceso",
  "/favoritos",
  "/auth",
  "/forgot-password",
  "/reset-password",
  "/prueba-tu-menu",
  "/landing-ads",
  "/software-recursos-humanos",
  "/referidos-info",
  "/r",
  // Comparativas con competidores: noindex hasta reescribirlas con fuentes.
  "/blog/olaclick-vs-plaxter-comparativa-2025",
  "/blog/calisto-ai-vs-plaxter-menu-digital-ia",
] as const;

export function isNoindexPath(pathname: string): boolean {
  const path = (pathname || "/").toLowerCase().replace(/\/+$/, "") || "/";
  return NOINDEX_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
